import { createCrudModule } from "../crud";

export function bookingQuery({ page = 1, length = 10, search = "", status = "", date_from = "", date_to = "", package_id = "" } = {}) {
  return Object.fromEntries(Object.entries({ paginate: page, size: length, search, status, date_from, date_to, package_id })
    .filter(([, value]) => value !== "" && value !== undefined && value !== null));
}

const bookingExportQuery = ({ search = "", status = "", date_from = "", date_to = "", package_id = "" } = {}) =>
  Object.fromEntries(Object.entries({ search, status, date_from, date_to, package_id })
    .filter(([, value]) => value !== "" && value !== undefined && value !== null));

const bookingActionPath = (id, action) => {
  if (id === undefined || id === null || id === "") throw new Error("A booking id is required.");
  return `packages/bookings/${encodeURIComponent(id)}/${action}`;
};

export function bookingListing(response) {
  const data = response?.data;
  const rows = Array.isArray(data) ? data : data?.data || data?.items || [];
  if (!Array.isArray(rows)) throw new Error("The booking list response is invalid.");
  return {
    rows,
    total: data?.total ?? response?.meta?.total ?? rows.length,
    lastPage: Number(data?.last_page ?? response?.meta?.last_page ?? 1),
  };
}

const packageBookingsModule = createCrudModule({
  name: "packageBookings",
  stateKey: "PackageBookings",
  endpoint: "packages/bookings",
  operations: {
    list: { query: bookingQuery, select: bookingListing },
    details: {},
    create: {},
    update: false,
    delete: false,
    manage: {
      method: "POST",
      path: ({ id, action }) => {
        if (id === undefined || id === null || id === "") throw new Error("A booking id is required.");
        if (!["confirm", "cancel", "complete", "reopen", "reschedule"].includes(action)) {
          throw new Error("A valid booking action is required.");
        }
        return bookingActionPath(id, action);
      },
      body: ({ data }) => data,
    },
    confirm: {
      method: "POST",
      path: ({ id }) => bookingActionPath(id, "confirm"),
      body: ({ data = {} }) => data,
    },
    export: {
      method: "GET",
      path: "packages/bookings/export",
      query: bookingExportQuery,
      responseType: "blob",
    },
  },
});

export default packageBookingsModule;
